import PropTypes from "prop-types";

export const inboxMessagePropType = PropTypes.shape({
  id: PropTypes.string,
  direction: PropTypes.string,
  status: PropTypes.string,
  body_text: PropTypes.string,
  metadata: PropTypes.object,
});

export const inboxConversationPropType = PropTypes.shape({
  id: PropTypes.string,
  contact_name: PropTypes.string,
  channel: PropTypes.string,
  status: PropTypes.string,
  external_thread_id: PropTypes.string,
  is_unread: PropTypes.bool,
  has_pending_draft: PropTypes.bool,
  is_message_request: PropTypes.bool,
  last_message_at: PropTypes.string,
  last_message_preview: PropTypes.string,
  message_count: PropTypes.number,
});

export const inboxSummaryPropType = PropTypes.object;
